import { Link } from "react-router-dom";
import { getArticle } from "@/mocks/articles";
import { MagazineCard } from "@/components/ui/ArticleView";
import SectionHeading from "@/components/ui/Section";

const SLUGS = [
  "shijing-shi-jixingren-jile",
  "yingshou-zhuo-shang-de-na-ju-zhenhua",
  "penfan-biao-shang-de-jiangjiu",
];

export default function FeaturedPicks() {
  const items = SLUGS.map((s) => getArticle(s)).filter(Boolean);
  return (
    <section className="mt-14 border-y border-background-200 bg-background-100 py-12 md:mt-20 md:py-16">
      <div className="container-page">
        <SectionHeading
          kicker="Editorial Picks"
          title="今日深度 · 编辑部精选"
          desc="八卦不只关乎是谁红、谁糊，更关乎这个圈子如何运转。精选三篇，带你从不同信源读懂圈内门道。"
          center
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {items.map((a) => a && <MagazineCard key={a.slug} a={a} />)}
        </div>
        <p className="mt-6 text-center">
          <Link
            to="/category/yenei"
            className="group inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            想看更多硬核业内观察？
            <i className="ri-arrow-right-circle-line transition-transform group-hover:translate-x-1"></i>
          </Link>
        </p>
      </div>
    </section>
  );
}